import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService } from '../../core/api.service';
import { LoggerService } from '../../core/logger.service';
import { UrlService } from '../../core/url.service';
import { WebSocketService } from '../../core/websocket.service';
import { SessionValidApiOutput } from '../models/api/sessionvalid-api.model';
import { RegionService } from 'src/app/core/region.service';
import { Region } from '../models';
import * as AuthActions from '../../actions/auth.actions';
import * as fromRoot from '../../reducers';
import { StoreClearAction } from '../../actions/core.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private sessionCheckInProgress?: Promise<boolean>;
  constructor(
    private apiService: ApiService,
    private loggerService: LoggerService,
    private router: Router,
    private store: Store<fromRoot.State>,
    private urlService: UrlService,
    private webSocketService: WebSocketService,
    private regionService: RegionService,
  ) {}
  public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // TODO this is hotfix for billing route redirection, need to refactor later
    const isBillingRoute = state.url.startsWith('/settings/billing');
    const hasUsRegionParam = next.queryParams['dr'] === Region.USCENTRAL;
    if (isBillingRoute && hasUsRegionParam) {
      this.regionService.redirectToRegion(Region.USCENTRAL);
    }

    if (!this.sessionCheckInProgress) {
      this.sessionCheckInProgress = this.apiService
        .execute<SessionValidApiOutput>('sessionvalid', {})
        .then((sessionValidApiOutput) => {
          this.urlService.setHostByType('news', sessionValidApiOutput.servers_news);
          this.webSocketService.connect();
          return true;
        })
        .catch((err) => {
          if (err.status === 453) {
            this.regionService.redirectToRegion(err.error.region, true);
            return;
          }
          this.loggerService.error('Session is not valid');
          this.loggerService.error(err);
          this.store.dispatch(new StoreClearAction());
          this.store.dispatch(new AuthActions.LogoutAction());
          if (this.router.url.startsWith('/dl/')) {
            const returnToLink = this.router.url;
            this.router.navigate(['/login'], { queryParams: { return_to_link: returnToLink } });
          } else {
            const returnTo = this.urlService.getReturnTo();
            this.router.navigate(['/login'], { queryParams: { return_to: returnTo } });
          }
          return false;
        })
        .finally(() => {
          this.sessionCheckInProgress = undefined;
        });
    }
    return this.sessionCheckInProgress;
  }
}
